import {
  AvailableImageType,
  GetIconForDerivativeIdRequestDto,
  GetIconForVehicleModelIdRequestDto,
} from '@tribal-worldwide-london/fa-image-service-vwg';
import { useEffect, useMemo, useState } from 'react';
import { useTribalContext } from '@/context/tribal';

const useFeaturedImages = (
  requestsData: {
    derivativeId: string;
    modelId: string;
    optionId: string;
    width: number;
    isStockCar: boolean;
    imageType: AvailableImageType;
  }[]
) => {
  const [images, setImages] = useState<string[]>([]);
  const { imageService } = useTribalContext();

  const imageUris: string[] = useMemo(
    () =>
      requestsData.map((request) => {
        if (request) {
          const {
            derivativeId,
            modelId,
            optionId,
            isStockCar,
            width = 516,
            imageType = 'png',
          } = request;

          if (isStockCar) {
            return imageService.getIconForVehicleModelIdPath(
              new GetIconForVehicleModelIdRequestDto(
                modelId,
                optionId,
                width,
                imageType
              )
            );
          } else {
            return imageService.getIconForVehicleDerivativeIdPath(
              new GetIconForDerivativeIdRequestDto(
                derivativeId,
                optionId,
                width,
                imageType
              )
            );
          }
        }

        return '';
      }),
    [requestsData]
  );

  useEffect(() => {
    if (imageUris.join('') !== images.join('')) setImages(imageUris);
  }, [requestsData]);


  return images;
};

export default useFeaturedImages;
